import geojsonArea from '@mapbox/geojson-area';
import moment from 'moment';

export function areaInM2(geojson) {
  return geojsonArea.geometry(geojson);
}

export function areaInKm2(geojson) {
  return geojsonArea.geometry(geojson) / 1000000;
}

export function areaInHa(geojson) {
  return geojsonArea.geometry(geojson) / 10000;
}

export function getErrorMessage(error) {
  return error ?.response ?.data ?.message ?.msg || error.message;
}

export function datePickerDate() {
  return new Date().toISOString().substr(0, 10);
}

export function datePickerDateToday() {
  return moment().toISOString().substr(0, 10);
}

export function datePickerDateYesterday() {
  return moment().add(-1, 'days').toISOString().substr(0, 10);
}

export function geoJsonAreaInKm2(geojson) {
  return geojsonArea.geometry(geojson.geometry) / 1000000;
}